import React from 'react';
import { Box, Checkbox, FormControl, FormControlLabel, MenuItem, Select, TextField, Typography, makeStyles } from '@material-ui/core';

interface FilterFieldProps {
    label: string;
    value: string | boolean;
    onChange: (value: string | boolean) => void;
    type?: 'text' | 'date' | 'select' | 'checkbox';
    placeholder?: string;
    options?: Array<{ value: string; label: string }>;
}

const useStyles = makeStyles({
    container: {
        marginBottom: '8px',
    },
    label: {
        fontWeight: 500,
        color: '#333',
        marginBottom: '4px',
        fontSize: '14px',
    },
    select: {
        height: '40px',
    },
    input: {
        fontSize: '14px',
        height: '40px',
    },
});

export const FilterField: React.FC<FilterFieldProps> = ({
    label,
    value,
    onChange,
    type = 'text',
    placeholder,
    options,
}) => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            {type === 'checkbox' ? (
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={value as boolean}
                            onChange={(e) => onChange(e.target.checked)}
                            color="primary"
                        />
                    }
                    label={
                        <Typography variant="body2" className={classes.label}>
                            {label}
                        </Typography>
                    }
                />
            ) : (
                <>
                    <Typography variant="body2" className={classes.label}>
                        {label}
                    </Typography>
                    {type === 'select' ? (
                        <FormControl variant="outlined" size="small" fullWidth>
                            <Select value={value} onChange={(e) => onChange(e.target.value as string)} className={classes.select}>
                                {options?.map((opt) => (
                                    <MenuItem key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    ) : (
                        <TextField
                            size="small"
                            type={type}
                            value={value as string}
                            onChange={(e) => onChange(e.target.value)}
                            variant="outlined"
                            fullWidth
                            placeholder={placeholder}
                            InputLabelProps={type === 'date' ? { shrink: true } : undefined}
                            InputProps={{
                                className: classes.input,
                            }}
                        />
                    )}
                </>
            )}
        </Box>
    );
};
